import React from 'react';
import { ShieldOff } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';

export default function AccessDenied() {
  const navigate = useNavigate();
  const { tenantSlug } = useParams();

  return (
    <div className="flex flex-col items-center justify-center h-full py-20 text-center">
      <div className="h-20 w-20 bg-red-50 rounded-2xl flex items-center justify-center mb-6">
        <ShieldOff size={36} className="text-red-400" />
      </div>
      <h1 className="text-2xl font-bold text-gray-800 mb-2">Acesso Negado</h1>
      <p className="text-gray-500 mb-6 max-w-xs">Você não tem permissão para acessar esta página.</p>
      <button
        onClick={() => navigate(tenantSlug ? `/${tenantSlug}/dashboard` : '/')}
        className="text-white px-6 py-2.5 rounded-xl text-sm font-medium"
        style={{ backgroundColor: 'var(--brand-primary)' }}
      >
        Voltar ao Dashboard
      </button>
    </div>
  );
}
